import { render, staticRenderFns } from "./invoice-tab.vue?vue&type=template&id=2444bab5&scoped=true"
import script from "./invoice-tab.vue?vue&type=script&lang=js"
export * from "./invoice-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2444bab5",
  null
  
)

export default component.exports